import React, { useState, useEffect } from "react";
import axios from "axios";
import { Card, CardContent, CardHeader, CardTitle } from "../../components/ui/card";
import { Button } from "../../components/ui/button";
import { Input } from "../../components/ui/input";
import { Label } from "../../components/ui/label";
import { Badge } from "../../components/ui/badge";
import { Textarea } from "../../components/ui/textarea";
import { Table, TableBody, TableCell, TableHead, TableHeader, TableRow } from "../../components/ui/table";
import { Select, SelectContent, SelectItem, SelectTrigger, SelectValue } from "../../components/ui/select";
import { toast } from "sonner";

const API = axios.create({ baseURL: `${process.env.REACT_APP_BACKEND_URL}/api` });
API.interceptors.request.use((c) => { const t = localStorage.getItem("abs_token"); if (t) c.headers.Authorization = `Bearer ${t}`; return c; });
const rp = (n) => (n == null ? "-" : `Rp ${Number(n).toLocaleString("id-ID")}`);
const clr = (s) => ({
  DRAFT: "bg-slate-500", SUBMITTED: "bg-blue-500", REVIEW: "bg-amber-500",
  APPROVED: "bg-emerald-500", REJECTED: "bg-red-600", READY_TO_PAY: "bg-indigo-500",
  PAID: "bg-green-700", CLOSED: "bg-gray-700",
  OPEN: "bg-emerald-500", PAUSED: "bg-amber-500", FILLED: "bg-teal-600",
  APPLIED: "bg-slate-500", SCREENING: "bg-blue-500", INTERVIEW: "bg-amber-500",
  ASSESSMENT: "bg-indigo-500", OFFER: "bg-teal-500", HIRED: "bg-green-700",
  WITHDRAWN: "bg-gray-500", SENT: "bg-blue-600", ACCEPTED: "bg-emerald-500",
  DECLINED: "bg-red-500", EXPIRED: "bg-gray-500",
  SESUAI: "bg-emerald-500", PERLU_DITINJAU: "bg-amber-500", ERROR: "bg-red-600",
  CLEAR: "bg-emerald-500", POSSIBLE_DUPLICATE: "bg-amber-500", DUPLICATE: "bg-red-500",
}[s] || "bg-slate-500");

// ============ CLAIM ============
export function ClaimHub() {
  return (
    <div className="p-6 space-y-4" data-testid="claim-hub">
      <h1 className="text-3xl font-bold">Klaim & Reimbursement</h1>
      <div className="grid md:grid-cols-3 gap-3">
        <a href="/klaim/list"><Card className="hover:shadow-md"><CardHeader><CardTitle>Klaim Saya</CardTitle></CardHeader><CardContent>Lihat / buat klaim personal.</CardContent></Card></a>
        <a href="/klaim/approval"><Card className="hover:shadow-md"><CardHeader><CardTitle>Approval Klaim</CardTitle></CardHeader><CardContent>Review, approve, reject.</CardContent></Card></a>
        <a href="/klaim/integritas"><Card className="hover:shadow-md"><CardHeader><CardTitle>Integritas Klaim</CardTitle></CardHeader><CardContent>10-check integrity.</CardContent></Card></a>
      </div>
    </div>
  );
}

export function ClaimListPage() {
  const [rows, setRows] = useState([]);
  const [cats, setCats] = useState([]);
  const [form, setForm] = useState({ category: "", expense_date: "", amount: 0, description: "" });
  const reload = () => API.get("/claim").then((r) => setRows(r.data)).catch(() => {});
  useEffect(() => { reload(); API.get("/claim/categories").then((r) => setCats(r.data)).catch(() => {}); }, []);
  const submit = async () => {
    try { await API.post("/claim", form); toast.success("Klaim dibuat"); reload(); setForm({ category: "", expense_date: "", amount: 0, description: "" }); }
    catch (e) { toast.error(e.response?.data?.detail || "Gagal"); }
  };
  const doAction = async (cid, ep) => {
    try { await API.post(`/claim/${cid}/${ep}`, {}); toast.success("OK"); reload(); }
    catch (e) { toast.error(e.response?.data?.detail || "Gagal"); }
  };
  return (
    <div className="p-6 space-y-4" data-testid="claim-list-page">
      <h1 className="text-2xl font-bold">Klaim Saya</h1>
      <Card><CardHeader><CardTitle>Buat Klaim</CardTitle></CardHeader><CardContent className="grid grid-cols-4 gap-3">
        <div><Label>Kategori</Label>
          <Select value={form.category} onValueChange={(v) => setForm({ ...form, category: v })}>
            <SelectTrigger data-testid="cat-select"><SelectValue /></SelectTrigger>
            <SelectContent>{cats.map((c) => (<SelectItem key={c.code} value={c.code}>{c.name}</SelectItem>))}</SelectContent>
          </Select></div>
        <div><Label>Tgl Pengeluaran</Label><Input type="date" value={form.expense_date} onChange={(e) => setForm({ ...form, expense_date: e.target.value })} data-testid="date-input" /></div>
        <div><Label>Jumlah</Label><Input type="number" value={form.amount} onChange={(e) => setForm({ ...form, amount: parseFloat(e.target.value) || 0 })} data-testid="amount-input" /></div>
        <div><Label>Deskripsi</Label><Input value={form.description} onChange={(e) => setForm({ ...form, description: e.target.value })} /></div>
        <Button onClick={submit} data-testid="submit-claim-btn">Simpan Draft</Button>
      </CardContent></Card>
      <Card><CardContent className="pt-4">
        <Table><TableHeader><TableRow><TableHead>Nomor</TableHead><TableHead>Kategori</TableHead><TableHead>Tanggal</TableHead><TableHead className="text-right">Jumlah</TableHead><TableHead>Status</TableHead><TableHead>Dup</TableHead><TableHead>Aksi</TableHead></TableRow></TableHeader>
          <TableBody>{rows.map((c) => (
            <TableRow key={c.id} data-testid={`claim-${c.number}`}>
              <TableCell className="font-mono">{c.number}</TableCell><TableCell>{c.category_name}</TableCell><TableCell>{c.expense_date}</TableCell><TableCell className="text-right">{rp(c.amount)}</TableCell>
              <TableCell><Badge className={clr(c.status)}>{c.status}</Badge></TableCell>
              <TableCell><Badge className={clr(c.duplicate_status)}>{c.duplicate_status}</Badge></TableCell>
              <TableCell className="space-x-1">
                {c.status === "DRAFT" && <Button size="sm" onClick={() => doAction(c.id, "submit")}>Ajukan</Button>}
              </TableCell></TableRow>
          ))}</TableBody></Table>
      </CardContent></Card>
    </div>
  );
}

export function ClaimApprovalPage() {
  const [rows, setRows] = useState([]);
  const reload = () => API.get("/claim?self_only=false").then((r) => setRows(r.data)).catch(() => {});
  useEffect(reload, []);
  const doAction = async (cid, ep, body = {}) => {
    try { await API.post(`/claim/${cid}/${ep}`, body); toast.success("OK"); reload(); }
    catch (e) { toast.error(e.response?.data?.detail || "Gagal"); }
  };
  return (
    <div className="p-6 space-y-4" data-testid="claim-approval-page">
      <h1 className="text-2xl font-bold">Approval Klaim</h1>
      <Table><TableHeader><TableRow><TableHead>Nomor</TableHead><TableHead>Karyawan</TableHead><TableHead>Kategori</TableHead><TableHead className="text-right">Jumlah</TableHead><TableHead>Status</TableHead><TableHead>Butuh Level</TableHead><TableHead>Aksi</TableHead></TableRow></TableHeader>
        <TableBody>{rows.map((c) => (
          <TableRow key={c.id}>
            <TableCell className="font-mono">{c.number}</TableCell><TableCell>{c.employee_code}</TableCell><TableCell>{c.category_name}</TableCell><TableCell className="text-right">{rp(c.amount)}</TableCell>
            <TableCell><Badge className={clr(c.status)}>{c.status}</Badge></TableCell>
            <TableCell className="text-xs">{(c.approval_levels_required || []).join(", ")}</TableCell>
            <TableCell className="space-x-1">
              {c.status === "SUBMITTED" && <Button size="sm" onClick={() => doAction(c.id, "review")}>Review</Button>}
              {c.status === "REVIEW" && <><Button size="sm" onClick={() => doAction(c.id, "approve", { approver_level: (c.approval_levels_required || ["MANAGER"])[0] })}>Setujui</Button>
                <Button size="sm" variant="destructive" onClick={() => doAction(c.id, "reject")}>Tolak</Button></>}
              {c.status === "APPROVED" && <Button size="sm" onClick={() => doAction(c.id, "post")}>Post GL</Button>}
              {c.status === "APPROVED" && <Button size="sm" variant="outline" onClick={() => doAction(c.id, "ready-pay")}>Siap Bayar</Button>}
              {c.status === "READY_TO_PAY" && <Button size="sm" onClick={() => doAction(c.id, "mark-paid")}>Bayar</Button>}
              {c.status === "PAID" && <Button size="sm" variant="outline" onClick={() => doAction(c.id, "close")}>Tutup</Button>}
            </TableCell></TableRow>
        ))}</TableBody></Table>
    </div>
  );
}

export function ClaimIntegrityPage() {
  const [d, setD] = useState(null);
  useEffect(() => { API.get("/claim-integrity").then((r) => setD(r.data)).catch(() => {}); }, []);
  if (!d) return <div className="p-6">Memuat…</div>;
  return (
    <div className="p-6 space-y-4" data-testid="claim-integrity-page">
      <div className="flex items-center gap-3">
        <h1 className="text-2xl font-bold">Integritas Klaim</h1>
        <Badge className={clr(d.overall)}>{d.overall}</Badge>
      </div>
      <Card><CardContent className="pt-4">
        <Table><TableHeader><TableRow><TableHead>#</TableHead><TableHead>Nama</TableHead><TableHead>Status</TableHead></TableRow></TableHeader>
          <TableBody>{d.checks.map((c, i) => (<TableRow key={i}><TableCell>{i + 1}</TableCell><TableCell>{c.name}</TableCell><TableCell><Badge className={clr(c.status)}>{c.status}</Badge></TableCell></TableRow>))}</TableBody></Table>
      </CardContent></Card>
    </div>
  );
}

// ============ RECRUITMENT ============
export function RecruitmentHub() {
  return (
    <div className="p-6 space-y-4" data-testid="recruitment-hub">
      <h1 className="text-3xl font-bold">Recruitment / ATS</h1>
      <div className="grid md:grid-cols-3 gap-3">
        <a href="/recruitment/mpr"><Card className="hover:shadow-md"><CardHeader><CardTitle>Manpower Request</CardTitle></CardHeader><CardContent>Permintaan kebutuhan pegawai.</CardContent></Card></a>
        <a href="/recruitment/vacancies"><Card className="hover:shadow-md"><CardHeader><CardTitle>Lowongan</CardTitle></CardHeader><CardContent>Daftar vacancy OPEN/PAUSED.</CardContent></Card></a>
        <a href="/recruitment/candidates"><Card className="hover:shadow-md"><CardHeader><CardTitle>Kandidat</CardTitle></CardHeader><CardContent>Master kandidat + pipeline.</CardContent></Card></a>
        <a href="/recruitment/offers"><Card className="hover:shadow-md"><CardHeader><CardTitle>Offer</CardTitle></CardHeader><CardContent>Offer FSM + hire convert.</CardContent></Card></a>
        <a href="/recruitment/integritas"><Card className="hover:shadow-md"><CardHeader><CardTitle>Integritas Recruitment</CardTitle></CardHeader><CardContent>8-check integrity.</CardContent></Card></a>
      </div>
    </div>
  );
}

export function MPRPage() {
  const [rows, setRows] = useState([]);
  const [form, setForm] = useState({ position: "", department: "", headcount: 1, reason: "" });
  const reload = () => API.get("/recruitment/manpower-requests").then((r) => setRows(r.data)).catch(() => {});
  useEffect(reload, []);
  const doAction = async (mid, to) => {
    try { await API.post(`/recruitment/manpower-requests/${mid}/transition`, { to_stage: to }); toast.success("OK"); reload(); }
    catch (e) { toast.error(e.response?.data?.detail || "Gagal"); }
  };
  return (
    <div className="p-6 space-y-4" data-testid="mpr-page">
      <h1 className="text-2xl font-bold">Manpower Request</h1>
      <Card><CardContent className="pt-4 grid grid-cols-5 gap-3">
        <Input placeholder="Posisi" value={form.position} onChange={(e) => setForm({ ...form, position: e.target.value })} data-testid="mpr-position" />
        <Input placeholder="Departemen" value={form.department} onChange={(e) => setForm({ ...form, department: e.target.value })} />
        <Input type="number" placeholder="Headcount" value={form.headcount} onChange={(e) => setForm({ ...form, headcount: parseInt(e.target.value) })} />
        <Input placeholder="Alasan" value={form.reason} onChange={(e) => setForm({ ...form, reason: e.target.value })} />
        <Button onClick={async () => { try { await API.post("/recruitment/manpower-requests", form); toast.success("MPR dibuat"); reload(); } catch (e) { toast.error(e.response?.data?.detail || "Gagal"); } }} data-testid="mpr-submit">Buat MPR</Button>
      </CardContent></Card>
      <Table><TableHeader><TableRow><TableHead>Nomor</TableHead><TableHead>Posisi</TableHead><TableHead>Dept</TableHead><TableHead>HC</TableHead><TableHead>Status</TableHead><TableHead>Aksi</TableHead></TableRow></TableHeader>
        <TableBody>{rows.map((m) => (
          <TableRow key={m.id}><TableCell className="font-mono">{m.number}</TableCell><TableCell>{m.position}</TableCell><TableCell>{m.department}</TableCell><TableCell>{m.headcount}</TableCell><TableCell><Badge className={clr(m.status)}>{m.status}</Badge></TableCell>
            <TableCell className="space-x-1">
              {m.status === "DRAFT" && <Button size="sm" onClick={() => doAction(m.id, "SUBMITTED")}>Ajukan</Button>}
              {m.status === "SUBMITTED" && <Button size="sm" onClick={() => doAction(m.id, "REVIEW")}>Review</Button>}
              {m.status === "REVIEW" && <Button size="sm" onClick={() => doAction(m.id, "APPROVED")}>Setujui</Button>}
              {m.status === "APPROVED" && <Button size="sm" onClick={() => doAction(m.id, "OPEN")}>Buka</Button>}
            </TableCell></TableRow>
        ))}</TableBody></Table>
    </div>
  );
}

export function VacancyPage() {
  const [rows, setRows] = useState([]);
  useEffect(() => { API.get("/recruitment/vacancies").then((r) => setRows(r.data)).catch(() => {}); }, []);
  return (
    <div className="p-6 space-y-4" data-testid="vacancy-page">
      <h1 className="text-2xl font-bold">Lowongan</h1>
      <Table><TableHeader><TableRow><TableHead>Nomor</TableHead><TableHead>Posisi</TableHead><TableHead>Departemen</TableHead><TableHead>Openings</TableHead><TableHead>Hired</TableHead><TableHead>Applied</TableHead><TableHead>Status</TableHead></TableRow></TableHeader>
        <TableBody>{rows.map((v) => (<TableRow key={v.id}><TableCell className="font-mono">{v.number}</TableCell><TableCell>{v.position}</TableCell><TableCell>{v.department}</TableCell><TableCell>{v.openings}</TableCell><TableCell>{v.hired_count || 0}</TableCell><TableCell>{v.applied_count || 0}</TableCell><TableCell><Badge className={clr(v.status)}>{v.status}</Badge></TableCell></TableRow>))}</TableBody></Table>
    </div>
  );
}

export function CandidatePage() {
  const [rows, setRows] = useState([]);
  const [form, setForm] = useState({ name: "", email: "", phone: "" });
  const reload = () => API.get("/recruitment/candidates").then((r) => setRows(r.data)).catch(() => {});
  useEffect(reload, []);
  return (
    <div className="p-6 space-y-4" data-testid="candidate-page">
      <h1 className="text-2xl font-bold">Kandidat</h1>
      <Card><CardContent className="pt-4 grid grid-cols-4 gap-3">
        <Input placeholder="Nama" value={form.name} onChange={(e) => setForm({ ...form, name: e.target.value })} />
        <Input placeholder="Email" value={form.email} onChange={(e) => setForm({ ...form, email: e.target.value })} />
        <Input placeholder="Telepon" value={form.phone} onChange={(e) => setForm({ ...form, phone: e.target.value })} />
        <Button onClick={async () => { try { await API.post("/recruitment/candidates", form); toast.success("Kandidat dibuat"); reload(); } catch (e) { toast.error(e.response?.data?.detail || "Gagal"); } }} data-testid="cand-submit">Simpan</Button>
      </CardContent></Card>
      <Table><TableHeader><TableRow><TableHead>Nomor</TableHead><TableHead>Nama</TableHead><TableHead>Email</TableHead><TableHead>Telepon</TableHead><TableHead>Expected</TableHead><TableHead>Duplikat</TableHead></TableRow></TableHeader>
        <TableBody>{rows.map((c) => (<TableRow key={c.id}><TableCell className="font-mono">{c.number}</TableCell><TableCell>{c.name}</TableCell><TableCell>{c.email}</TableCell><TableCell>{c.phone}</TableCell><TableCell>{c.expected_salary === "*****" ? <Badge>PROTECTED</Badge> : rp(c.expected_salary)}</TableCell><TableCell>{c.duplicate_of_candidate_id ? <Badge className="bg-amber-500">DUP</Badge> : "-"}</TableCell></TableRow>))}</TableBody></Table>
    </div>
  );
}

export function OfferPage() {
  const [rows, setRows] = useState([]);
  const reload = () => API.get("/recruitment/offers").then((r) => setRows(r.data)).catch(() => {});
  useEffect(reload, []);
  const doAction = async (oid, to) => { try { await API.post(`/recruitment/offers/${oid}/transition`, { to_stage: to }); toast.success("OK"); reload(); } catch (e) { toast.error(e.response?.data?.detail || "Gagal"); } };
  return (
    <div className="p-6 space-y-4" data-testid="offer-page">
      <h1 className="text-2xl font-bold">Offer</h1>
      <Table><TableHeader><TableRow><TableHead>Nomor</TableHead><TableHead>Kandidat</TableHead><TableHead>Posisi</TableHead><TableHead>Salary</TableHead><TableHead>Start</TableHead><TableHead>Status</TableHead><TableHead>Aksi</TableHead></TableRow></TableHeader>
        <TableBody>{rows.map((o) => (<TableRow key={o.id}><TableCell className="font-mono">{o.number}</TableCell><TableCell>{o.candidate_name}</TableCell><TableCell>{o.position}</TableCell><TableCell>{rp(o.salary)}</TableCell><TableCell>{o.start_date}</TableCell><TableCell><Badge className={clr(o.status)}>{o.status}</Badge></TableCell>
          <TableCell className="space-x-1">
            {o.status === "DRAFT" && <Button size="sm" onClick={() => doAction(o.id, "REVIEW")}>Review</Button>}
            {o.status === "REVIEW" && <Button size="sm" onClick={() => doAction(o.id, "APPROVED")}>Setujui</Button>}
            {o.status === "APPROVED" && <Button size="sm" onClick={() => doAction(o.id, "SENT")}>Kirim</Button>}
            {o.status === "SENT" && <><Button size="sm" onClick={() => doAction(o.id, "ACCEPTED")}>Accepted</Button><Button size="sm" variant="destructive" onClick={() => doAction(o.id, "DECLINED")}>Declined</Button></>}
          </TableCell></TableRow>))}</TableBody></Table>
    </div>
  );
}

export function RecruitmentIntegrityPage() {
  const [d, setD] = useState(null);
  useEffect(() => { API.get("/recruitment-integrity").then((r) => setD(r.data)).catch(() => {}); }, []);
  if (!d) return <div className="p-6">Memuat…</div>;
  return (
    <div className="p-6 space-y-4" data-testid="recruitment-integrity-page">
      <div className="flex items-center gap-3">
        <h1 className="text-2xl font-bold">Integritas Recruitment</h1>
        <Badge className={clr(d.overall)}>{d.overall}</Badge>
      </div>
      <Card><CardContent className="pt-4">
        <Table><TableHeader><TableRow><TableHead>#</TableHead><TableHead>Nama</TableHead><TableHead>Status</TableHead></TableRow></TableHeader>
          <TableBody>{d.checks.map((c, i) => (<TableRow key={i}><TableCell>{i + 1}</TableCell><TableCell>{c.name}</TableCell><TableCell><Badge className={clr(c.status)}>{c.status}</Badge></TableCell></TableRow>))}</TableBody></Table>
      </CardContent></Card>
    </div>
  );
}
